import { createContext, useContext, useEffect, useMemo, type PropsWithChildren } from "react";
import type { Backend } from "./contracts";
import { createBackend } from "./factory";

const BackendContext = createContext<Backend | null>(null);

export function BackendProvider({ children, backend }: PropsWithChildren<{ backend?: Backend }>) {
  const value = useMemo(() => backend ?? createBackend(), [backend]);
  useEffect(() => { if (import.meta.env.DEV) (window as Window & { __cftodoBackend?: Backend }).__cftodoBackend = value; }, [value]);
  return <BackendContext.Provider value={value}>{children}</BackendContext.Provider>;
}

export function useBackend(): Backend {
  const backend = useContext(BackendContext);
  if (!backend) throw new Error("BackendProvider is missing.");
  return backend;
}
